export default "__VITE_ASSET__BSNB0_If__"